export default {
    updateSidebarState(state, payload) {
        Object.assign(state.sidePanelSettings, payload);
    }
}